const ARREDO_CHANNELS = ['GOP'];
const UW_CHANNELS = ['GOS', 'BYS', 'BAS'];

export const isArredoChannel = (channel: string) => {
  return ARREDO_CHANNELS.includes(channel);
};

/**
 * Check if channel is part of 'United Web' sites: Golvshop, Badshop, Byggshop
 */
export const isUWChannel = (channel: string): boolean => {
  return UW_CHANNELS.includes(channel);
};
